"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleAnalyticsSender = /** @class */ (function () {
    function GoogleAnalyticsSender(dataObjectGoogle, dataObjectMatomo, logger) {
        this.dataObjectGoogle = dataObjectGoogle;
        this.dataObjectMatomo = dataObjectMatomo;
        this.logger = logger;
    }
    GoogleAnalyticsSender.prototype.send = function (event) {
        if (this.dataObjectGoogle) {
            this.dataObjectGoogle.push(event);
        }
        if (this.dataObjectMatomo) {
            this.dataObjectMatomo.push(event);
        }
    };
    return GoogleAnalyticsSender;
}());
exports.default = GoogleAnalyticsSender;
